import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Flex from "components/common/Flex";
import SubtleBadge from "components/common/SubtleBadge";

const NavbarVerticalMenuItem = ({ route }) => {
  return (
    <div className="d-flex align-items-center">
      {route.icon && (
        // <span className="nav-link-icon">
        //   <FontAwesomeIcon icon={route.icon} />
        // </span>
        <span
          className="nav-link-icon"
          style={{ paddingLeft: 0, paddingRight: 2 }}
        >
          <div style={{ fontSize: "20px" }}>{route.icon}</div>
        </span>
      )}
      <span className="nav-link-text ps-1 pt-1">{route.name}</span>
      {route.badge && (
        <SubtleBadge pill bg={route.badge.type} className="ms-2">
          {route.badge.text}
        </SubtleBadge>
      )}
    </div>
  );
};

// prop-types
const routeShape = {
  active: PropTypes.bool,
  name: PropTypes.string,
  to: PropTypes.string,
  // icon: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
};
routeShape.children = PropTypes.arrayOf(PropTypes.shape(routeShape));
NavbarVerticalMenuItem.propTypes = {
  route: PropTypes.shape(routeShape).isRequired,
};

export default React.memo(NavbarVerticalMenuItem);
